/**
 * Footer del portal · vive al fondo del `<main>` del AppShell (empujado por
 * `flex-1` del contenido, así que se queda pegado abajo aunque la página sea
 * corta y baja con el scroll si es larga). Diseño simple y CENTRADO. Tokens
 * duales para respetar claro/oscuro.
 */
export function AppFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-auto border-t border-border bg-card/60 px-4 py-4 md:px-6">
      <div className="flex items-center justify-center text-xs text-muted-foreground">
        <p className="text-center">
          © {year} <span className="font-semibold text-foreground">Portal de proveedores</span>
        </p>
      </div>
    </footer>
  );
}
